module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am631-74d11a69453c24b319c064720b2061fc.jpg";